exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".setting-drawer-index-item[data-v-51558778] {\n  margin-bottom: 24px;\n}\n.setting-drawer-index-item .setting-drawer-index-title[data-v-51558778] {\n  font-size: 14px;\n  color: rgba(0, 0, 0, 0.85);\n  line-height: 22px;\n  margin-bottom: 12px;\n}\n", ""]);

// exports
